import React from 'react';
import styled from 'styled-components';
import Supercashback from '@catalogo/ui-americanas-mobile-supercashback';
import BestPrice from '@catalogo/ui-americanas-mobile-best-price';
import MainOption from '@catalogo/ui-americanas-mobile-payment-option';
import { formatPrice } from '@catalogo/core-helpers/price';
import { withPaymentOption } from '@catalogo/service-americanas-product/src/payment';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';
import { SecondaryOption } from './components/secondary-option';

export const Buybox = ({
  defaultPrice,
  buyTogether,
  hasSuperCashback,
  contentModalAme,
  secondaryPayment,
  mainPayment,
  prime,
  international,
  history,
}) => {
  if (!mainPayment) {
    return (
      <Wrapper>
        <BestPrice defaultPrice={defaultPrice} />
      </Wrapper>
    );
  }

  if (buyTogether) {
    return (
      <Wrapper>
        <Price>{`R$ ${formatPrice(buyTogether)}`}</Price>
        <span>com item sugerido</span>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Supercashback hasSuperCashback={hasSuperCashback} contentModalAme={contentModalAme} />
      <BestPrice international={international} prime={prime} defaultPrice={defaultPrice} payment={mainPayment} />
      <MainOption payment={mainPayment} />
      <SecondaryOption payment={secondaryPayment} />
      <MorePaymentMethods onClick={replaceUrlParams(history, '#modal-payment-methods', false)}>
        mais formas de pagamento
      </MorePaymentMethods>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  padding: 30px 0;
  font-size: 14px;
`;

const Price = styled.div`
  font-size: 30px;
  line-height: 1.2;
  font-weight: 600;
  text-align: left;
  line-height: normal;
  margin: 0px;
`;

const MorePaymentMethods = styled.div`
  margin-top: 10px;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export default withPaymentOption(Buybox);
